// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_48-0";
export var eligibilityCardNotEligible = "_48-1";